import MoreVertIcon from "@mui/icons-material/MoreVert";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React, { FC, useState } from "react";
import { WorkspacesTableRowDefinition } from "../../types";
import { ActionOption, createMenuActions } from "./utils";

interface ActionCellProps {
  row: WorkspacesTableRowDefinition;
  onActionClick: (
    action: ActionOption,
    row: WorkspacesTableRowDefinition
  ) => void;
}

export const ActionCell: FC<ActionCellProps> = (props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleActionClick = (
    action: ActionOption,
    row: WorkspacesTableRowDefinition
  ) => {
    props.onActionClick(action, row);
    handleClose();
  };

  const menuActions = createMenuActions({
    handleActionClick,
    row: props.row,
  });

  return (
    <>
      <IconButton
        data-testid="workspace-row-actions-btn"
        size="small"
        onClick={handleClick}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        id="workspace-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableAutoFocus
        disableAutoFocusItem
        onClick={(e) => e.stopPropagation()}
        slotProps={{
          paper: {
            elevation: 1,
            sx: {
              minWidth: 200,
              maxWidth: 300,
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.15))",
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {menuActions.map((item) => {
          const icon = item.renderIcon ? item.renderIcon(props.row) : item.icon;
          const label = item.renderLabel
            ? item.renderLabel(props.row)
            : item.label;

          return (
            <div key={label}>
              {item.dividerBefore && <Divider />}
              <MenuItem
                data-testid={item.testId}
                onClick={() => item.onClick(props.row)}
                dense
              >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText>{label}</ListItemText>
              </MenuItem>
            </div>
          );
        })}
      </Menu>
    </>
  );
};
